/* @index('./*.ts', f => `export * from '${f.path}';`) */
export * from './activity-notation.model';
export * from './activity.model';
export * from './address.model';
export * from './affinity.model';
export * from './announcement.model';
export * from './card.model';
export * from './comment.model';
export * from './coordinates.model';
export * from './customization-settings.model';
export * from './document.model';
export * from './enjoyment.model';
export * from './event-subscription.model';
export * from './event.model';
export * from './interest.model';
export * from './inventory.model';
export * from './location.model';
export * from './notification-check.model';
export * from './notification.model';
export * from './partner.model';
export * from './passport.model';
export * from './picto.model';
export * from './place.model';
export * from './position.model';
export * from './presentation-page.model';
export * from './prestation-availability.model';
export * from './prestation-reservation.model';
export * from './prestation-subscription.model';
export * from './prestation.model';
export * from './profile.model';
export * from './region.model';
export * from './report.model';
export * from './reservation.model';
export * from './stay-creation-code.model';
export * from './stay.model';
export * from './tip.model';
export * from './translatable-string';
export * from './up-conversation.model';
export * from './up-message.model';
export * from './user.model';
/* @endindex */
